export default "__VITE_ASSET__mMsndriZ__"